export const TRAFFIC_MONITORING_TITLE = '交通量監視路線設定';
export const TXT_CREATE_NEW = '新規作成';
export const TXT_SAVE = '保存'

export const TXT_START_DAYTIME = '昼夜開始時刻';
export const TXT_START_NIGHTTIME = '深夜開始時刻';
export const TXT_CAUTION_COLOR = '注意色';
export const TXT_WARNING_COLOR = '警報色';

// Column Names
export const COL_NAME_MANAGEMENT_ID = 'No';
export const COL_NAME_ROUTE_NAME = '名称';
export const COL_NAME_ROUTE_DATA = '路線データ';
export const COL_NAME_TRAFFIC_DIRECTION = '交通方向';
export const COL_NAME_TRAFFIC_LINKED_SENSORS = '紐付け交通量';
export const COL_NAME_CAMERA = 'カメラ';
export const COL_NAME_SCENARIO_NO = '断面No';
export const COL_NAME_DAYTIME = '昼夜';
export const COL_NAME_NIGHTTIME = '深夜';
export const COL_NAME_CAUTION = '注意';
export const COL_NAME_WARNING = '警報';

// Messages
export const MSG_CREATE_SUCCESS = '交通量監視路線を作成しました。';
export const MSG_UPDATE_SUCCESS = '交通量監視路線を更新しました。';
export const MSG_DELETE_SUCCESS = '交通量監視路線を削除しました。';
export const MSG_ERROR = 'エラーが発生しました。';
export const MSG_CONFIRM_DELETE = '本当に削除してもよろしいですか？';

